const delay = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(
      () => resolve(),
      ms,
    )
  })
}

export default delay



// WEBPACK FOOTER //
// ./src/utils/delay/delay.ts